import React from "react";
import { GestorGeoreferencia } from '../components/VerificacionGeoreferencia';
import Layout from "../components/Layout";
const VerificacionGeoreferencia = () => {
  return (
    <>
      <Layout/>
        <div>
            <GestorGeoreferencia/>
        </div>
    </>
  );
};

export default VerificacionGeoreferencia;

